import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import utilsHelpers from "utilities/helpers/helpers-utils/1.0.0/js/helpers-utils";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.5/js/helpers-sparta";
/**
 * Handlebars Path Helpers
 * Copyright (c) 2013 Jon Schlinkert, Brian Woodward, contributors
 * Licensed under the MIT License (MIT).
 */

'use strict';

// The module to be exported
const helpers = {
  radioButton(data) {
    const requiredAttrs = ['id'];
    const reservedAttrs = ['type', 'name', 'data-help-link', 'data-help-head', 'data-help-body'];
    const combinableAttrs = { class: 'spa-input-option spa-input-option--radio', value: '' };
    let sRadioButtonGroup = '';

    const dataHelpToggle = data.helpToggle ? data.helpToggle : data.label;
    const dataADAHiddenLabel = data.adaHiddenLabel ? data.adaHiddenLabel : false;

    for (let i = 0, len = data.radioButtons.length; i < len; i += 1) {
      const radioButton = data.radioButtons[i];
      const oAttributeGroup = {};
      let attrsStr;

      const helpToggle = radioButton.helpToggle ? radioButton.helpToggle : radioButton.label.text;

      if (!Handlebars.helpers.requiredAttrsCheck(radioButton.radioButton.attrs, requiredAttrs).pass) {
        /*serverSideOnly*/
        throw new Error("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(radioButton.radioButton.attrs, requiredAttrs).missingField);
        /*serverSideOnly*/

        if (window.console && console.log) {
          console.log("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(radioButton.radioButton.attrs, requiredAttrs).missingField);
          return "";
        }
      }

      Handlebars.helpers.extend({}, oAttributeGroup, radioButton.radioButton.attrs);
      Handlebars.helpers.removeReservedAttrs(oAttributeGroup, reservedAttrs);
      Handlebars.helpers.combineAttrs(oAttributeGroup, combinableAttrs);
      attrsStr = Handlebars.helpers.buildAttrsString(oAttributeGroup);

      var sRadioOptionWrapper = "<div class='spa-input-options-wrapper" +
                    ((radioButton.radioButton.attrs["data-help-body"]) ? " has-help" : "") +
                    "'" +
                    ((radioButton.radioButton.conditionalContent) ? " data-option-has-conditional-content data-conditional-content='" + radioButton.radioButton.conditionalContent + "'" : "") +
                    ">";

      var sRadioOption = "<input type='radio' " + attrsStr +
                   " name='" + data.name + "'" +
                   ((radioButton.disabled || data.disabled) ? " disabled aria-disabled='true'" : "") +
                   " />" +
                 "<span class='spa-input-check'>&#160;</span>";

      var sRadioOptionLabel = "<label class='spa-input-option-label' data-font='cnx-regular'" +
                    " for='" + radioButton.radioButton.attrs.id + "'>" +
                    radioButton.label.text +
                    "<span class='ada-hidden'>" +
                      ((radioButton.label.adaText) ? radioButton.label.adaText : "") +
                    "</span>" +
                  "</label>";

      let sRadioOptionHint = ''; // TBD

      let sRadioConditionalContent = '';

      if (radioButton.radioButton.attrs['data-help-body']) {
        // Add a help pop-up trigger, either a question mark or some link text.
        const triggerText = radioButton.radioButton.attrs['data-help-link'] || '';
        const triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
        const sRadioOptionHelpTrigger = `<a href="javascript: void(0);" id="help-open-${radioButton.radioButton.attrs.id}" role="button" aria-label="${helpToggle}" class="${triggerClass}">${triggerText || '&#160;'}</a>`;

        var sRadioOptionHelpContainer = "<div class='input-help' id='helpLayer_" + radioButton.radioButton.attrs.id +
                        "' role='tooltip' aria-hidden='true' >";

        var sRadioOptionHelpClose = "<a href='javascript:void(0)' id='help-close-" + radioButton.radioButton.attrs.id +
                      "' role='button' aria-label='" + helpToggle + "' class='close-trigger svg-button'>&#160;</a>";

        var sRadioOptionHelpBody = "<div class='body'>" + radioButton.radioButton.attrs["data-help-body"] + "</div>";

        if (radioButton.radioButton.attrs["data-help-head"]) {
          sRadioOptionHelpBody = "<div class='head' data-font='cnx-bold'>" +
                         radioButton.radioButton.attrs["data-help-head"] +
                       "</div>" +
                       sRadioOptionHelpBody;
        }

        if (radioButton.radioButton.conditionalContent) {
          sRadioConditionalContent = "<div id='" + radioButton.radioButton.attrs.id + "_conditional-content' class='spa-input-option-conditional-content' data-option-conditional-content></div>";
        }

        sRadioOptionHelpContainer += sRadioOptionHelpClose + sRadioOptionHelpBody + "</div>";
        sRadioOptionWrapper += sRadioOption + sRadioOptionLabel + sRadioOptionHelpTrigger + sRadioOptionHint + sRadioOptionHelpContainer + sRadioConditionalContent + "</div>";
      } else {
        sRadioOptionWrapper += sRadioOption + sRadioOptionLabel + sRadioOptionHint + sRadioConditionalContent + "</div>";
      }

      sRadioButtonGroup += sRadioOptionWrapper;
    }

    const triggerText = data['data-help-link'] || '';
    const helpText = data['data-help-body'] || '';
    const vBind = data['data-v-bind'] ?  ("data-v-bind=" + data['data-v-bind']) : '';
    let inlineTriggerClass = '';
    let clearFixClassName = '';

    if (helpText && !triggerText) {
      inlineTriggerClass = ' inline-legend-icon';
      clearFixClassName = ' clearfix';
    }

    var sRadioGroupContainer = "<div class='spa-input spa-input-options spa-input--" +
                   ((data.skin) ? data.skin : "sparta2") +
                   ((data.darkBackground) ? " spa-input-options--inverse" : "") +
                   ((data.containerClasses) ? " " + data.containerClasses.join(" ") : "") +
                   ((data["data-help-body"]) ? " has-help" : "") +
                   "'>";

    var sRadioGroupFieldset = `<fieldset class="spa-fieldset${clearFixClassName}" id="${data.id}" ` +
                  ((data.validationRules) ? (" data-validation-rules='" + JSON.stringify(data.validationRules).replace(/'/g, "&#39;") + "'") : "") +
                  ((data.required) ? " required aria-required='true'" + ((typeof data.required === 'string') ? ' data-required-error-message="' + data.required + '"' : '') : "") +
                  ">";

    const inputLabelRequiredSpan = (required, asterisk) => {
      if (required && asterisk === false) {
        return "<span class='spa-input-label--required'></span>";
      } else if (required) {
        return "<span class='spa-input-label--required'> *</span>";
      }
      return "";
    };

    var sRadioGroupFieldsetLabel = `<legend class="spa-fieldset-label${inlineTriggerClass}" for="${data.id}" aria-hidden="${dataADAHiddenLabel}">` +
                       data.label +
                       ( inputLabelRequiredSpan(data.required, data.asterisk) ) +
                       "<span class='ada-hidden'>" +
                         ((data.adaText) ? data.adaText : "") +
                       "</span>" +
                     "</legend>";

    var sRadioGroupWrapper = "<div " + vBind + " class='spa-input-options-list--" + ((data.direction) ? data.direction : "vertical") + "'>" +
                    sRadioButtonGroup +
                    ((data.direction) ? "<div class='horizontal-clear'></div>" : "") +
                  "</div>";

    var sRadioGroupHint = "<p class='spa-input-options-hint'>" +
                  ((data.hintText) ? data.hintText : "") +
                "</p>";

    var sRadioGroupError = "<div id='" + data.id + "_errorMessage' class='spa-input-error-message spa-icon--error' aria-hidden='true'></div>";

    if (data['data-help-body']) {
      // Add a help pop-up trigger, either a question mark or some link text.
      const triggerText = data['data-help-link'] || '';
      const triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
      const wrapperClass = triggerText ? '' : 'class="flex-wrapper"';
      const sRadioGroupHelpTrigger = `<a href="javascript: void(0);" id="help-open-${data.id}" role="button" aria-label="${dataHelpToggle}" class="${triggerClass}">${triggerText || '&#160;'}</a>`;

      var sRadioGroupHelpContainer = "<div class='input-help' id='helpLayer_" + data.id +
                       "' role='tooltip' aria-hidden='true' >";

      var sRadioGroupHelpClose = "<a href='javascript:void(0)' id='help-close-" + data.id +
                     "' role='button' aria-label='" + dataHelpToggle + "' class='close-trigger svg-button'>&#160;</a>";

      var sRadioGroupHelpBody = "<div class='body'>" + data["data-help-body"] + "</div>";

      if (data['data-help-head']) {
        sRadioGroupHelpBody = "<div class='head' data-font='cnx-bold'>" +
                      data["data-help-head"] +
                    "</div>" +
                    sRadioGroupHelpBody;
      }

      sRadioGroupHelpContainer += sRadioGroupHelpClose + sRadioGroupHelpBody + "</div>";
      sRadioGroupFieldset += "<div " + wrapperClass + ">" + sRadioGroupFieldsetLabel + sRadioGroupHelpTrigger +  "</div>" + sRadioGroupHelpContainer + sRadioGroupWrapper + sRadioGroupHint + sRadioGroupError + "</fieldset>";
    } else {
      sRadioGroupFieldset += sRadioGroupFieldsetLabel + sRadioGroupWrapper + sRadioGroupHint + sRadioGroupError + "</fieldset>";
    }

    sRadioGroupContainer += sRadioGroupFieldset + "</div>";

    return new Handlebars.SafeString(sRadioGroupContainer);
  }
};

// Export helpers
module.exports.register = function (Handlebars, options) {
  options = options || {};
  for (var helper in helpers) {
    if (helpers.hasOwnProperty(helper)) {
      Handlebars.registerHelper(helper, helpers[helper]);
    }
  }
};

module.exports.helpers = helpers;
